import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Thumbs, Autoplay, Mousewheel, FreeMode } from 'swiper/modules';
window.Swiper = Swiper;

window.SwiperModes = {
    'Navigation': Navigation,
    'Pagination': Pagination,
    'Grid': Grid,
    'Thumbs': Thumbs,
    'Mousewheel': Mousewheel,
    'FreeMode': FreeMode,
};

let mainSlider = new Swiper('#main_slider', {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    pagination: {
        el: '.main__pagination-holder',
        clickable: true,
        bulletClass: 'main__pagination-item',
        bulletActiveClass: 'main__pagination-item_active'
    },
    speed: 2000,
    loop: true,
    autoplay: {
        delay: 10000,
    },
})